import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NonAuthRoutes, RouteParamsTypes, Modules } from '../enums';
import Forbidden from '../components/ErrorPages/Forbidden';
import NotFound from '../components/ErrorPages/NotFound';
import UnHandledRejection from '../components/ErrorPages/UnHandledRejection';
import ErrorPage from '../modules/errorPage';

const Errors: React.FC = () => {
  return (
    <Routes>
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.forbidden }} />}
      />
      <Route path={NonAuthRoutes.forbidden} element={<ErrorPage component={Forbidden} />} />
      <Route path={NonAuthRoutes.notFound} element={<ErrorPage component={NotFound} />} />
      <Route
        path={NonAuthRoutes.unHandledRejection + RouteParamsTypes.id}
        element={<ErrorPage component={UnHandledRejection} />}
      />
    </Routes>
  );
};

export default Errors;
